import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'year-picker2',
    template: `
    <div>
        <div class="col-xs-2" style="padding:0px;padding-left:5px;width:57%;">
        <select style="padding:0px;" class="form-control" id="year" name="getyear" required>
            <option *ngFor="let y of years"  [selected]="yy === y ">{{y}}</option>
        </select>
        </div>
    </div>`
})

export class YearPickerComponent2 implements OnInit {

    years: number[] = [];
    private yy: number;

    ngOnInit() {
        this.getYear();
    }

    getYear() {
        var today = new Date();
        this.yy = today.getFullYear();
        for (var i = (this.yy - 8); i <= this.yy; i++) {
            this.years.push(i);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/monthpicker/YearPicker2.ts